import React from 'react'
function TitleStyle() {
  return React.createElement(
    'div',
    null,
    React.createElement(
      'style',
      null,
      '\n        .map-title {\n          text-anchor: start;\n          font-size: 18px;\n        }\n\n        .legend-title {\n          fill: gray;\n          text-anchor: end;\n          font-size: 8px;\n        }\n      '
    )
  )
}
export default TitleStyle
